// src/redux/modules/counterSlice.js

import { createSlice, current } from "@reduxjs/toolkit";

// 초기값
const initialState = [
     {
          id: 1,
          title: "리액트 강의보기",
          body: "챕터 1부터 챕터 12까지 학습",
          isDone: false,
     },
     {
          id: 2,
          title: "점심 먹기",
          body: "점심 뭐먹지..?",
          isDone: false,
     },
];
//리듀서
let id = 3;

const TodosSlice = createSlice({
     name: "Todos",
     initialState,
     reducers: {
          addTodo: (state, action) => {
               // 함수 -- return 꼭 || push 메소드라서 가능
               return state.concat({ ...action.payload, id: id++ }); // 기존에 있던 배열에 넣는거기 때문에 push는 return 없이 가능// concst은 새로운 배열이기 때문에 return 필요
          },
          deleteTodo: (state, action) => {
               return state.filter((todo) => todo.id !== action.payload);
               // console.log(current(state));
               // console.log(action.payload);
          },
          toggleStateTodo: (state, action) => {
               return [
                    ...state.map((todo) => {
                         if (todo.id === action.payload) {
                              return { ...todo, isDone: !todo.isDone };
                         }
                         return todo;
                    }),
               ];
          },
     },
});

export const { addTodo, deleteTodo, toggleStateTodo } = TodosSlice.actions;
export default TodosSlice.reducer;
